var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5 96.5625C26.6126 96.5625 6.4375 76.3809 6.4375 51.5C6.4375 26.6191 26.6126 6.4375 51.5 6.4375C76.3874 6.4375 96.5625 26.6191 96.5625 51.5C96.5625 76.3809 76.3874 96.5625 51.5 96.5625ZM51.5 0C23.0559 0 0 23.0462 0 51.5C0 79.9538 23.0559 103 51.5 103C79.9441 103 103 79.9538 103 51.5C103 23.0462 79.9441 0 51.5 0Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/ErrorCircle.1e026bb05314ea2cee17aaba94b62361.svg";
export { ForwardRef as ReactComponent };